import { useDraggable } from "@dnd-kit/core";
import {CSS} from "@dnd-kit/utilities"
import React from "react";

export function DommusDraggable({children, id}){
  const {attributes, listeners, setNodeRef, transform, isDragging} = useDraggable({
    id: id,
  });

  const style = {
    opacity: isDragging ? `0.4` : '1',
    display: 'flex',
    width: "100%"
  };

  return (
    <div ref={setNodeRef}  style={style} {...attributes} {...listeners}>
      {children}
    </div>
  )
}
